module.exports = __webpack_public_path__ + "static/img/ligo_16.7fd0f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/ligo_16.png
// module id = LlUd
// module chunks = 0